(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lian-completed-work"] && !Shopify.designMode) return;
  try {
    
function initCompletedFeed(root){if(root.dataset.ready)return;root.dataset.ready='1';const items=[...root.querySelectorAll('.lcw-work')],button=root.querySelector('[data-more]'),status=root.querySelector('.lcw-load p');let count=6;function render(){items.forEach((item,i)=>item.hidden=i>=count);button.hidden=count>=items.length;status.textContent=Math.min(count,items.length)+' of '+items.length+' completed works';}function next(){count+=6;render();}button.addEventListener('click',next);if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)&&count<items.length)next();},{rootMargin:'200px'});observer.observe(button);}render();}document.querySelectorAll('[data-lcw]').forEach(initCompletedFeed);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lcw]').forEach(initCompletedFeed));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lian-custom-portfolio"] && !Shopify.designMode) return;
  try {
    
function initLianPortfolio(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const cards=[...root.querySelectorAll('.lcp-card')],filters=[...root.querySelectorAll('[data-filter]')],more=root.querySelector('.lcp-more'),showing=root.querySelector('.lcp-showing'),dialog=root.querySelector('dialog'),viewer=dialog.querySelector('img');
  let active='all',limit=8,photos=[],index=0;
  filters.forEach(button=>{const key=button.dataset.filter;button.querySelector('span').textContent=key==='all'?cards.length:cards.filter(c=>c.dataset.category===key).length;button.addEventListener('click',()=>{active=key;limit=8;filters.forEach(b=>b.setAttribute('aria-pressed',String(b===button)));render();});});
  function render(){const matches=cards.filter(c=>active==='all'||c.dataset.category===active);cards.forEach(c=>c.hidden=!matches.includes(c)||matches.indexOf(c)>=limit);more.hidden=matches.length<=limit;showing.textContent=Math.min(limit,matches.length)+' / '+matches.length;}
  more.addEventListener('click',()=>{limit+=8;render();});
  function view(){const photo=photos[index];viewer.src=photo.href;viewer.alt=photo.textContent;dialog.querySelector('h3').textContent=photo.textContent;dialog.querySelector('.lcp-dialog-caption p').textContent=(index+1)+' / '+photos.length;dialog.querySelector('[data-prev]').hidden=photos.length<2;dialog.querySelector('[data-next]').hidden=photos.length<2;}
  cards.forEach(card=>card.querySelector('[data-open]').addEventListener('click',()=>{photos=[...card.querySelectorAll('.lcp-image-data a')];index=0;view();dialog.showModal();}));
  dialog.querySelector('[data-prev]').addEventListener('click',()=>{index=(index-1+photos.length)%photos.length;view();});dialog.querySelector('[data-next]').addEventListener('click',()=>{index=(index+1)%photos.length;view();});
  dialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight'){index=(index+1)%photos.length;view();}if(event.key==='ArrowLeft'){index=(index-1+photos.length)%photos.length;view();}});
  dialog.addEventListener('click',event=>{if(event.target===dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();}});
  render();
}
document.querySelectorAll('[data-lcp]').forEach(initLianPortfolio);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lcp]').forEach(initLianPortfolio));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
